import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { handleSignOut } from "../../utils/firebase";
import { useMyData } from '../../context/data-context.component';
import "./navbar.styles.css"

const NavBar = ({backgroundColor = "white", color = "black"}) => {

  const { user, ttsUsageRef, lookUpRef } = useMyData()

  const location = useLocation();
  const isHome = location.pathname === '/';
  const isLWT = location.pathname === '/learn-with-text';
  const isLWTHelper = location.pathname === '/text-helper';
  return (
    <nav
      className = "nav-bar"
      style={{
        display: "flex",
        justifyContent: "flex-end",
        // padding: "0 10px",
        // fontSize: "14px",
        // borderBottom: "none",
        // textDecoration: "none",
        zIndex: 2,
        backgroundColor,
        color
      }}
    > {isHome && (
        <>
      <Link to="/about" style={{ marginLeft: 20, textDecoration: "none", color: "inherit", borderBottom: "none"}}>
        How To
      </Link>
      <Link to="/mypage" style={{ margin: "0 20px" , textDecoration: "none", color: "inherit", borderBottom: "none"}}>
        My Page
      </Link>
      </>)}

     {user && !isHome && isLWTHelper && (
  <>
    <Link to="/learn-with-text" style={{ margin: "0 20px", textDecoration: "none", color: "inherit"}}>
      Back
    </Link>
  </>
     )}
     {user && !isHome && isLWT && (
  <>
    <Link to="/" style={{ marginLeft: 20, textDecoration: "none", color: "inherit"}}>
      Home
    </Link>
    <Link to="/text-helper" style={{ marginLeft: 20, textDecoration: "none", color: "inherit"}}>
      Resources
    </Link>
    <Link to="/" onClick={() => handleSignOut(user, ttsUsageRef, lookUpRef)} style={{ margin: "0 20px", textDecoration: "none", color: "inherit"}}>
      Log Out
    </Link>
  </>
     )}
{user && !isHome && !isLWT && !isLWTHelper && (
  <>
    <Link to="/" style={{ marginLeft: 20, textDecoration: "none", color: "inherit"}}>
      Home
    </Link>
    <Link to="/" onClick={() => handleSignOut(user, ttsUsageRef, lookUpRef)} style={{ margin: "0 20px", textDecoration: "none", color: "inherit"}}>
      Log Out
    </Link>
  </>
)}


{!user && !isHome && (
  <>
<Link to="/" style={{ margin: "0 20px", textDecoration: "none", color: "inherit"}}>
  Home
</Link>
</>)}

      {/* {!isHome && !isMyPage && (
        <>
       <Link to="/" style={{ marginLeft: 15, textDecoration: "none", color: "#333" }}>
        Home
       </Link>
      </>
      )} */}
    </nav>
  );
}

export default NavBar
  
